import { render, staticRenderFns } from "./QuotaManagement.vue?vue&type=template&id=5051dcd1&scoped=true"
import script from "./QuotaManagement.vue?vue&type=script&lang=js"
export * from "./QuotaManagement.vue?vue&type=script&lang=js"
import style0 from "./QuotaManagement.vue?vue&type=style&index=0&id=5051dcd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5051dcd1",
  null
  
)

export default component.exports